import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Pin from '@Components/Pin';
import Img from '@UI/Img';
import styles from './InteriorImage.module.css';

import type { HomeIdeaData } from '@Types/Ideas';
import type { FC, HTMLAttributes, MutableRefObject } from 'react';
import type { PinAnalytics } from '@Components/Pin';

export interface InteriorImageProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  img: HomeIdeaData;
  refGrid: MutableRefObject<HTMLDivElement>;
  animated?: boolean;
  analyticsData: PinAnalytics;
}

const InteriorImage: FC<InteriorImageProps> = (props) => {
  const { className, img, refGrid, analyticsData, animated, ...restProps } = props;

  return (
    <>
      <Img
        {...restProps}
        className={cn(styles.imageWrapper, className)}
        cnImage={styles.image}
        src={img.src}
        alt={img.alt}
      />
      {img.pins.map((pin) => (
        <Pin
          animated={animated}
          key={`${pin.product.id}${pin.coords}`}
          pinCoords={pin.coords}
          product={pin.product}
          refGrid={refGrid}
          analyticsData={analyticsData}
        />
      ))}
    </>
  );
};

export default memo(InteriorImage);
